<template>

  <client-header></client-header>

    <div class="page">

        <kt-datatable
          :model="customerModel"  
          :data="list"
          @cell-click="handleCellClick"
        >
          <template #header_select="scope">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                :checked="selectAll"
                @change="toggleSelectAll"
                @click.stop
                title="Select all on this page"
              />
            </div>
          </template>
          
          <template #view_select="scope">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                :checked="selectedRows.includes(scope.row.Id)"
                @change="toggleRowSelection(scope.row.Id)"
                @click.stop
              />
            </div>
          </template>
          
          <template #view_actions="scope">
            <kt-dropmenu v-model:visible="actionDropdown['row_' + scope.row.Id]">
              <template #button>
                <button
                    class="btn btn-sm"
                    @click="actionDropdown['row_' + scope.row.Id] = !actionDropdown['row_' + scope.row.Id]"
                >
                  <span><i class="fas fa-ellipsis-v"></i></span>
                </button>
              </template>
              <template #dropmenu>
                <ul class="dropdown-menu show">
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
                        <i class="fa fa-edit"></i> Edit
                      </button>
                    </label>
                  </li>
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-info form-control" @click="viewStaff(scope.row)">
                        <i class="fa fa-user"></i> Contacts
                      </button>
                    </label>
                  </li>
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-danger form-control" @click="deleteClient(scope.row.Id)">
                        <i class="fa fa-trash"></i> Delete
                      </button>
                    </label>
                  </li>
                </ul>
              </template>

              <template #after-search="scope">
                <div class="-btn-group">
                <button @click="refresh()" 
                    class="btn btn-sm btn-outline-secondary"
                >Refresh <i class="fa fa-sync"></i></button>

                <button @click="newRecord()" 
                    class="btn btn-sm btn-outline-primary"
                >New <i class="fa fa-plus"></i></button>
                </div>
            </template>


            </kt-dropmenu>
          </template>

          <template #view_string="scope">

            <span v-if="scope.column.name == 'Company'">
              <a href="javascript:void(0);" @click="editRecord(scope.row.Id)">
                {{ scope.value || 'N/A' }}
              </a>
            </span>

            <span v-else-if="scope.column.name == 'Code'">
              <a href="javascript:void(0);" @click="editRecord(scope.row.Id)">
                {{ scope.value || 'N/A' }}
              </a>
            </span>

            <span v-else>{{ scope.value || 'N/A' }}</span>

          </template>

          <template #after-search="scope">
            <div class="-btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary me-2"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>
        
        <template #under-header>
          <!-- Bulk Actions Toolbar -->
          <div v-if="selectedRows.length > 0" class="mb-0 p-2 actions-row">
            <div class="d-flex align-items-center gap-2">
              <span class="fw-bold text-primary">{{ selectedRows.length }} selected</span>

              <!-- fix here ... -->
              <button
                v-if="selectedRows.length == 1"
                class="btn btn-sm btn-outline-secondary"
                @click="viewStaff(list[selectedRows[0] - 1])" 
                title="Set Priority"
              >
                <i class="fas fa-user-plus"></i> Contact
              </button>

              <button 
                class="btn btn-sm btn-outline-danger"
                @click="showDeleteModal = true"
                title="Delete Selected"
              >
                <i class="fas fa-trash"></i> Delete
              </button>
              <button 
                class="btn btn-sm btn-outline-secondary me-auto"
                @click="clearSelection"
              >
                Clear Selection
              </button>
            </div>
          </div>
        </template>
          
        </kt-datatable>
        
        <!-- Bulk Delete Confirmation Modal -->
        <kt-modal
          :visible="showDeleteModal"
          title="Confirm Bulk Delete"
          @dismiss="showDeleteModal = false"
        >
          <template #body>
            <div class="container-fluid">
              <p class="text-danger mb-3">
                <i class="fas fa-exclamation-triangle"></i>
                Are you sure you want to delete {{ selectedRows.length }} customer(s)?
              </p>
            </div>
          </template>
          <template #footer>
            <button class="btn btn-secondary" @click="showDeleteModal = false">Cancel</button>
            <button class="btn btn-danger" @click="confirmBulkDelete">Delete</button>
          </template>
        </kt-modal>
      
        <!-- Custom Contact Form -->
        <kt-modal
          :title="staffListTitle"
          :visible="staffListVisible"
          @dismiss="staffListDismiss()"
        >
          <template #body>
          <!-- Customer Information Header -->
          <div class="card mb-3 bg-light border-primary" v-if="toggled">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="mb-2 text-primary">
                    <i class="fas fa-building"></i> {{ toggled.Company || 'N/A' }}
                  </h6>
                  <p class="mb-1 small">
                    <strong>Code:</strong> {{ toggled.Code || 'N/A' }}
                  </p>
                  <p class="mb-0 small" v-if="toggled.Phone">
                    <strong>Phone:</strong> {{ toggled.Phone }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="mb-1 small">
                    <strong>Customer #:</strong> {{ toggled.CustomerNumber || 'N/A' }}
                  </p>
                  <p class="mb-0 small" v-if="toggled.ContactInformation">
                    <strong>Address:</strong><br>
                    <span style="white-space: pre-line;">{{ toggled.ContactInformation }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Contact List -->
          <h6 class="mb-2"><strong>Contacts</strong></h6>
          <ul class="list-group">
            <li v-for="row in staff"
                class="list-group-item"
            >
              <div class="row">
                <div class="col-8">
                  <small>{{ row.Name }} : {{ row.Email }}</small>
                </div>
                <div class="col-4 text-end">
                  <div class="-btn-group">
                    <button class="btn btn-sm btn-outline-danger" @click="staffDelete(row)">
                      <i class="fa fa-trash"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary" @click="staffEdit(row)">
                      <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="!staff.length">
              <small><em>No Contacts Found</em></small>
            </li>
          </ul>
          <button class="btn btn-outline-secondary btn-sm mt-3" @click="addStaff()">
            <!-- <i class="fa fa-add"></i> -->
            <span>Add Contact</span>
          </button>
          </template>
        </kt-modal>
        <kt-modal
            :title="staffTitle"
            :visible="staffVisible"
            @dismiss="staffDismiss()"

        >
            <template #body>
                <staff-form v-model="staffForm"></staff-form>
            </template>

            <template #footer>
                <div class="container-fluid px-0">
                    <div class="row">
                        <div class="col">
                            <button 
                                @click="staffDismiss()" 
                                class="btn btn-sm btn-outline-secondary form-control"
                            >Close</button>
                        </div>
                        <div class="col">
                            <button 
                                @click="staffSave(staffForm)" 
                                class="btn btn-sm btn-outline-primary form-control"
                            >Save</button>
                        </div>
                    </div>
                </div>
            </template>

        </kt-modal>

        <router-view name="modal"></router-view>
    </div>
    
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { storeToRefs } from "pinia";
import Api from "@/services/Api";
import Emitter from "@/services/Emitter";
import Validator from "@/services/Validator";

import ClientHeader from "./ClientHeader.vue";

import Alert from "@/services/Alert";
import StaffForm from "@/components/Staff/StaffForm.vue";

import KtInput from "@/components/UI/KtInput.vue";
import KtModal from '@/components/UI/KtModal.vue';
import KtDropmenu from '@/components/UI/KtDropmenu.vue';
import { useClientStore } from '@/stores/ClientStore';
import KtDatatable from "@/components/UI/KtDatatable.vue";

const router = useRouter();
const clientStore = useClientStore();
const { list } = storeToRefs(clientStore);
const filter = ref("");
const unlisten = [];

const staffListTitle = ref("Contact List");
const staffListVisible = ref(false);

const staffTitle = ref("New Contact");
const staffVisible = ref(false);
const staffForm = ref({});

const toggled = ref({});
const staff = ref([]);
const actionDropdown = ref({});

// Selection state
const selectedRows = ref([]);
const selectAll = ref(false);
const showDeleteModal = ref(false);

const handleCellClick = (row, column, value, rowIndex) => {
    // For now, edit record on any cell click (except Select column which has @click.stop)
    // You can add custom logic based on column.name or column.type here
    if (column.name !== 'Select') {
        editRecord(row.Id);
    } 
    
    else {
        toggleRowSelection(row.Id);
    }
};

const customerModel = [
  {
    name: "Select",
    label: "Select",
    type: "select",
    width: 60,
    locked: true,
    draggable: false
  },
  /*
  {
    name: "Actions",
    label: "Actions",
    type: "actions",
    overflow: true,
  },
  */
  {
    name: "Id",
    display: false
  },
  {
    name: "CustomerNumber",
    label: "Customer Number",
    display: false,
  },
  {
    name: "Code",
    display: true,
  },
  {
    name: "Company",
    display: true,
  },
  {
    name: "RoundTripMileage",
    label: "Round Trip Mileage",
    display: false,
  },
  {
    name: "ContactInformation",
    label: "Contact Information",
    display: false,
  },
  {
    name: "Status",
    display: true,
    type: "boolean",
  },
  {
    name: "Phone",
    display: true
  }
];

const viewStaff = async (contact) =>
{
    // load client staff
    staff.value = await Api.loadStaff({
        CustomerNo: [contact.CustomerNumber],
        Page: 0,
        Size: 999999999
    });

    toggled.value = contact;
    staffListVisible.value = true;
};

const staffListDismiss = () =>
{
    staffListVisible.value = false;
}

const newRecord = () =>
{
    router.push({
        path: "/client/edit/new"
    });
};

const editRecord = (id) =>
{
    router.push({
        path: "/client/edit/" + id
    });

};

const staffSave = async (staff) =>
{

    let errs = Validator.checkStaff(staff);

    if (errs.length)
    {
        Alert.notify({
            text: errs.join(" ")
        });
        return;
    }

    await Api.saveStaff(staff);
    await viewStaff(toggled.value);

    staffDismiss();
    
};

const refresh = () =>
{
    clientStore.reload();
};

unlisten.push(Emitter.on("refresh", refresh));

const dismissModal = () =>
{
    router.push({
        path: "/"
    });
};

const addStaff = () =>
{
    let client = toggled.value;
    let staff = {};
    
    staff.ClientMap = [client.CustomerNumber];

    staffForm.value = staff;
    staffTitle.value = "Add Contact";
    staffVisible.value = true;
};

const staffEdit = async (row) =>
{
    let staff = await Api.loadStaffById(row.Id);

    console.debug(staff);

    // loop through clients and set customer numbers
    let cm = [];
    staff.ClientMap.forEach((val) => {
        // cm.push(val.CustomerNumber);
        cm.push(val.ClientRef);
    });


    staff.ClientMap = cm;
    
    staffForm.value = staff;
    staffTitle.value = "Edit Contact";
    staffVisible.value = true;

};

const staffDelete = (row) =>
{
    Alert.confirm("Do you want to remove that contact?", async () => {
        await Api.deleteStaff(row.Id);
        // await toggleRow(toggled.value);
        viewStaff(toggled.value);
    });
};

const staffDismiss = () =>
{
    staffVisible.value = false;
};

const deleteClient = (id) =>
{
    Alert.confirm("Are you sure you want to delete this client?", async () => {
        try {
            await Api.deleteClient(id);
            await clientStore.reload();
            Alert.notify({
                text: "Client deleted successfully",
                type: "success"
            });
        } catch (error) {
            Alert.notify({
                text: "Error deleting client: " + error.message,
                type: "error"
            });
        }
    });
};

const filtered = computed(() => 
{
    const filtered = [];
    const regOption = new RegExp(filter.value, "ig");
    for (const option of list.value) 
    {
        if (!filter.value || (option.Company || option.Code || "").match(regOption))
        {
            filtered.push(option);
        }
    }

    return filtered;
});

onMounted(async () =>
{
    await clientStore.reload();
});

// ===== SELECTION MANAGEMENT =====

const toggleRowSelection = (rowId) => {
  const index = selectedRows.value.indexOf(rowId);
  if (index > -1) {
    selectedRows.value.splice(index, 1);
  } else {
    selectedRows.value.push(rowId);
  }
  updateSelectAllState();
};

const toggleSelectAll = () => {
  if (selectAll.value) {
    selectedRows.value = [];
    selectAll.value = false;
  } else {
    selectedRows.value = list.value.map((row) => row.Id);
    selectAll.value = true;
  }
};

const updateSelectAllState = () => {
  if (list.value.length === 0) {
    selectAll.value = false;
    return;
  }
  const allSelected = list.value.every((row) => selectedRows.value.includes(row.Id));
  selectAll.value = allSelected;
};

const clearSelection = () => {
  selectedRows.value = [];
  selectAll.value = false;
};

// ===== BULK ACTIONS =====

const confirmBulkDelete = async () => {
  if (selectedRows.value.length === 0) return;
  
  try {
    for (const id of selectedRows.value) {
      await Api.deleteClient(id);
    }
    Alert.notify({ text: `Successfully deleted ${selectedRows.value.length} customer(s)`, type: 'success' });
    clearSelection();
    await clientStore.reload();
  } catch (error) {
    console.error('Error deleting customers:', error);
    Alert.notify({ text: 'Failed to delete some customers', type: 'error' });
  }
  
  showDeleteModal.value = false;
};

onUnmounted(() =>
{
    unlisten.forEach((unlisten) => unlisten());
});


</script>

<style scoped>
/* Datatable link hover effect - blue theme with edit icon badge */
:deep(td a) {
    text-decoration: none;
    color: #333;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    position: relative;
}

:deep(td a:hover) {
    background-color: #15486A;
    color: #fff;
}

/* Edit icon badge in top-right corner on hover */
:deep(td a:hover::after) {
    content: '\f044';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #3B9796;
    color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 2px solid white;
}
</style>